<template>
  <v-container>
    <h4>Cleaning supply list</h4>
    <v-row
        v-for="(item, i) in cleaning_supply_list"
        :key="i"
      >
        <v-col
          cols="1"
        >
          {{ i+1 }}
        </v-col>
        <v-col
          cols="11"
        >
          {{ item.name }}
          <br/>
          <small>Price: {{ item.price }}</small>
        </v-col>
      </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'CleaningSupplyList',
  components: { },
  props: ['cleaning_supply_list'],
  data: () => ({ }),
  methods: { }
}
</script>